import { StyledAdminElementsWrapper } from './styles';
interface IAdminElementsWrapperProps {
  children?: React.ReactNode;
}
export const AdminElementsWrapper = ({ children }: IAdminElementsWrapperProps) => {
  return <StyledAdminElementsWrapper>{children}</StyledAdminElementsWrapper>;
};
